import { appInfo } from '@/mocks/homeData';

export default function App() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="bg-background-50 rounded-2xl p-6 md:p-10 flex flex-col lg:flex-row items-center gap-8 md:gap-12">
            <div className="flex-shrink-0 w-48 md:w-56">
              <div className="relative w-full aspect-[9/16] rounded-2xl overflow-hidden bg-background-200 shadow-lg">
                <img
                  src={appInfo.image}
                  alt="911吃瓜网APP界面"
                  className="w-full h-full object-cover object-top"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    if (target.parentElement) {
                      target.parentElement.style.display = 'none';
                    }
                  }}
                />
              </div>
            </div>

            <div className="flex-1 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
                {appInfo.title}
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
                {appInfo.desc}
              </p>

              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <button className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-800 text-background-50 rounded-lg text-sm font-medium hover:bg-foreground-900 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                  <i className="ri-apple-line text-lg"></i>
                  App Store 下载
                </button>
                <button className="inline-flex items-center gap-2 px-5 py-2.5 bg-secondary-100 text-secondary-800 rounded-lg text-sm font-medium hover:bg-secondary-200 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                  <i className="ri-android-line text-lg"></i>
                  安卓版下载
                </button>
              </div>

              <div className="mt-4 flex flex-wrap items-center justify-center lg:justify-start gap-4 text-xs text-foreground-500">
                <span>
                  <i className="ri-checkbox-circle-line text-accent-500 mr-1"></i>
                  推送通知实时提醒
                </span>
                <span>
                  <i className="ri-checkbox-circle-line text-accent-500 mr-1"></i>
                  夜间模式护眼阅读
                </span>
                <span>
                  <i className="ri-checkbox-circle-line text-accent-500 mr-1"></i>
                  离线缓存随时看
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}